import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Button, ButtonToolbar} from 'reactstrap';

export default class NewPromptChildComponent extends PureComponent {
  static propTypes = {
    cancel: PropTypes.string.isRequired,
    color: PropTypes.string,
    colored: PropTypes.bool,
    message: PropTypes.string,
    modal: PropTypes.object,
    ok: PropTypes.string.isRequired,
    icon: PropTypes.any,
    iconColor: PropTypes.any,
    buttonColor: PropTypes.any,
    link: PropTypes.any,
    title: PropTypes.string.isRequired

  } // END propTypes

  promptResult = confirmation => {
    const { modal } = this.props;
    if (modal) modal.toggle(confirmation);

  } // END promptResult

  render() {
    const { title, message, cancel, colored, ok, icon, iconColor,  buttonColor, link } = this.props;

    return (
       <React.Fragment>
          <div className='modal__header'>
            { icon &&  <span className={`lnr lnr-${icon} modal__title-icon ${iconColor}`}   /> }
            { title && <h4 className='bold-text  modal__title-new'>{ title }</h4> }
          </div>
          {
            message &&
            <div className='modal__message'>
              { message }
            </div>
          }
          <ButtonToolbar className='modal__footer'>
            <Button className='cancel__btn' onClick={ () => this.promptResult('cancel') }>
              { cancel }
            </Button>
            { link &&
              <a className='ok__btn link__sat' target="_blank" rel="noopener noreferrer" href={link} >{ ok }</a>
            }
            {
              !link &&
              <Button className='ok__btn' onClick={ () => this.promptResult('ok') } outline={ colored } color={ buttonColor }>
                { ok }
              </Button>
            }
          </ButtonToolbar>
       </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modals/NewPromptChildComponent.js